/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import cx from 'classnames'
import * as styles from '../setup.steps.styl'

export interface Props {
  type?: string
  name?: string
  className?: string
  label: string
  placeholder?: string
  value: string
  user?: any
  readOnly?: boolean
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  togglePassword?: () => void
  validation?: React.ReactNode
}

export const InputField: React.FC<Props> = ({
  type = 'text',
  className,
  name,
  label,
  placeholder = '',
  value = '',
  readOnly = false,
  handleChange,
  handleBlur,
  togglePassword,
  validation,
  children
}: React.PropsWithChildren<Props>) => (
  <div className={styles.validationWrapper} role="validation-wrapper">
    <div className={styles.fieldWrapper} role="field-wrapper">
      <div className={styles.label} role="label">
        {label}
      </div>
      <div
        className={cx(styles.inputWrapper, { [styles.readonly]: readOnly })}
        role="input-wrapper"
      >
        <input
          role="field"
          type={type}
          name={name || type}
          placeholder={placeholder}
          className={cx(className, styles[type])}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          readOnly={readOnly}
        />
        {togglePassword && (
          <i
            className={cx('material-icons', styles.togglePassword)}
            onClick={togglePassword}
            role="password-icon"
          >
            {type === 'password' ? 'visibility' : 'visibility_off'}
          </i>
        )}
      </div>
      {children || null}
    </div>
    {validation || null}
  </div>
)
